import { POST } from "../../index";

export const getAnnualApproveList = (param) => POST("/v1/AnnualApprove/getAnnualApproveList", param);
export const batchUpdateAudit = (param) => POST("/v1/AnnualApprove/batchUpdateAudit", param);
export const updateAudit = (param) => POST("/v1/AnnualApprove/updateAudit", param);
